import { NavLink } from "react-router-dom";

import Link from "@/components/Link";
import { PageRoute } from "@/constants/pages";

import Header from "../Header";
import PromoCard from "./PromoCard";

export type Promotion = {
  id: number;
  code: string;
  description: string;
  expires?: number;
  createdAt: number;
};

export type CurrentPromotionsProps = {
  promos: Promotion[];
};

export default function CurrentPromotions({ promos }: CurrentPromotionsProps) {
  if (!(promos?.length > 0)) {
    return null;
  }
  return (
    <>
      <div className="mb-4 mt-5 flex items-center justify-between">
        <Header className="text-xl" as="h2">
          Current Promotions
        </Header>
        <Link
          to={PageRoute.PROMOTIONS}
          as={NavLink}
          className="text-right text-xs"
        >
          See More
        </Link>
      </div>
      <div>
        {promos.slice(0, 2).map((p: Promotion) => (
          <PromoCard key={p.id} promo={p} />
        ))}
      </div>
    </>
  );
}
